import { useRef, RefObject } from 'react';

interface Props {
    scrollContainerRef: RefObject<HTMLDivElement>;
    onUpClick: () => void;
    onDownClick: () => void;
}

export const useScrollControl = (scrollAmount: number = 50): Props => {
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    // 위로 스크롤하는 함수
    const onUpClick = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop -= scrollAmount;
        }
    };

    // 아래로 스크롤하는 함수
    const onDownClick = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop += scrollAmount;
        }
    };

    return { scrollContainerRef, onUpClick, onDownClick };
};